/* eslint-disable prettier/prettier */
import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

import VendasOnlineParceiroTabs from './VendasOnlineParceiroTabs';
import VendasOnlineParceiroPreview from './VendasOnlineParceiroPreview';
import Loading from 'common/components/progress/loading';

class VendasOnlineParceiroModal extends React.Component {
  handleClose = (event, reason) => {
    //console.log('VendasOnlineParceiroModal handleClose chamado, reason:', reason)
    this.props.handleOpenConfirmation();
  };

  render() {
    const {
      visible,
      height,
      form,
      value,
      goBack,
      handleNativeChange,
      handleOpenConfirmation,
      handleCancelClose,
      openConfirmation,
      setOpenConfirmation,
      closeModal,
      onClickProgress,
      router,
      location,
      editMode,
      activityId,
    } = this.props;

    return (
      <Dialog
        open={visible}
        onClose={this.handleClose}
        fullWidth
        fullScreen={isMobile}
        maxWidth="xl"
        PaperProps={{ style: { minHeight: height || '90vh' } }}
        aria-labelledby="vendas-online-parceiro-dialog"
        disableEnforceFocus
        disableAutoFocus
      >
        <Box
          style={{
            backgroundColor: '#323232',
            color: '#fff',
            padding: isMobile ? 16 : 24,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant="h6" style={{ fontWeight: 'bold' }}>
            {editMode ? 'Editar Vendas Online com Parceiro' : 'Nova Vendas Online com Parceiro'}
          </Typography>
          <IconButton onClick={this.handleClose} style={{ color: '#fff' }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <DialogContent style={{ padding: 0 }}>
          <Grid container>
            <Grid item xs={12} md={5} style={{ padding: 16 }}>
              <VendasOnlineParceiroTabs
                value={value}
                formValues={form}
                goBack={goBack}
                handleNativeChange={handleNativeChange}
                handleOpenConfirmation={handleOpenConfirmation}
                handleCancelClose={handleCancelClose}
                openConfirmation={openConfirmation}
                setOpenConfirmation={setOpenConfirmation}
                closeModal={closeModal}
                onClickProgress={onClickProgress}
                router={router}
                location={location}
                editMode={editMode}
                activityId={activityId}
              />
            </Grid>

            {!isMobile && (
              <Grid
                item
                xs={12}
                md={7}
                style={{ borderLeft: '3px solid #f7f7f7', overflowY: 'auto' }}
              >
                {form ? (
                  <VendasOnlineParceiroPreview formValues={form} activeSection={value} />
                ) : (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    style={{ height: '100%' }}
                  >
                    <Loading />
                  </Box>
                )}
              </Grid>
            )}
          </Grid>
        </DialogContent>

        {/* Modal de Confirmação de Saída */}
        <Dialog
          open={openConfirmation}
          onClose={handleCancelClose}
          maxWidth="xs"
          fullWidth
          disableEnforceFocus
          disableAutoFocus
        >
          <Box style={{ padding: 24, textAlign: 'center' }}>
            <IconButton
              onClick={handleCancelClose}
              style={{ position: 'absolute', right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" style={{ marginBottom: 16 }}>
              Deseja sair da edição?
            </Typography>
            <Typography variant="body2" color="textSecondary" style={{ marginBottom: 24 }}>
              Lembre-se, as informações que não foram salvas serão perdidas.
            </Typography>
            <Box style={{ display: 'flex', justifyContent: 'center', gap: 16 }}>
              <Button
                onClick={handleCancelClose}
                color="primary"
              >
                Continuar aqui
              </Button>
              <Button
                onClick={closeModal}
                variant="contained"
                color="primary"
              >
                Sim, sair da edição
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Dialog>
    );
  }
}

VendasOnlineParceiroModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.number.isRequired,
  form: PropTypes.object,
  goBack: PropTypes.func.isRequired,
  handleNativeChange: PropTypes.func.isRequired,
  handleOpenConfirmation: PropTypes.func.isRequired,
  handleCancelClose: PropTypes.func.isRequired,
  openConfirmation: PropTypes.bool.isRequired,
  setOpenConfirmation: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  onClickProgress: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  editMode: PropTypes.bool,
  activityId: PropTypes.number,
};

const mapStateToProps = (state) => ({
  form: getFormValues('vendasOnlineParceiroForm')(state),
  auth: state.auth,
});

export default connect(mapStateToProps)(VendasOnlineParceiroModal);
